import { FC } from 'react'
import styles from './SleepAndHealthReportOverview.module.scss'
import { AlternatingGridProps, GridCardProps, SleepAndHealthReportOverviewProps } from './types'
import { SleepReportNotification } from './Notification'
import { getDefaultItems } from 'components/Phantom/_sections/SleepAndHealthReportOverview/utils'
import { CardHintProps } from 'components/Phantom/_sections/AutopilotBriefer/types'
import { Icon } from 'components/Phantom/Icon'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import isChromatic from 'chromatic'
import { Type } from 'components/Type'

export const SleepAndHealthReportOverview: FC<SleepAndHealthReportOverviewProps> = (props) => {
	const { items = getDefaultItems() } = props

	useGSAP(() => {
		if (isChromatic()) return
		gsap.registerPlugin(ScrollTrigger)
		gsap.from('#notification-sleep-report', {
			opacity: 0,
			y: 100,
			duration: 1,
			ease: 'power1.out',

			scrollTrigger: {
				trigger: '#notification-sleep-report',
				toggleActions: 'restart none none reverse',
				start: 'top 50%+=200px',
				end: '+=200',
			},
		})
	})

	return (
		<section className={styles.container}>
			<div className={styles.wrapper}>
				<header className={styles.header}>
					<Type.Headline2>Your Sleep & Health Report is ready</Type.Headline2>
					<Type.Body1>Each morning, view your metrics from the night before, and also take a glance at how they changed over time.</Type.Body1>
				</header>

				<div
					className={styles.notification_container}
					id={'notification-sleep-report'}
				>
					<SleepReportNotification />
				</div>

				<article>
					<AlternatingGrid items={items} />
				</article>
			</div>
		</section>
	)
}

export const AlternatingGrid: FC<AlternatingGridProps> = (props) => {
	return (
		<ul className={styles.grid}>
			{props.items.map((item, index) => (
				<li key={item.title}>
					<GridCard {...item} />
				</li>
			))}
		</ul>
	)
}

export const GridCard: FC<GridCardProps> = (props) => {
	return (
		<div className={styles.grid_card}>
			<div className={styles.card_component}>{props.component}</div>

			<header className={styles.card_header}>
				<Type.Eyebrow className={styles.card_eyebrow}>{props.eyebrow}</Type.Eyebrow>
				<Type.Headline3 className={styles.card_title}>{props.title}</Type.Headline3>
				<Type.Body1 className={styles.card_description}>{props.description}</Type.Body1>
				<Type.SmallPrint className={styles.dislcaimer}>{props.disclaimer}</Type.SmallPrint>
			</header>

			<CardHint {...props.hint} />
		</div>
	)
}

const CardHint: FC<CardHintProps> = (props) => {
	if (!props || !props.text) {
		return null
	}

	return (
		<div className={styles.card_hint_wrapper}>
			<div className={styles.card_hint}>
				<Icon
					name={props.icon}
					size={24}
					color={'black'}
					className={styles.card_icon}
				/>
				<p>{props.text}</p>
			</div>
		</div>
	)
}
